import React from 'react';

const webDevBenefitsData = [
  {
    id: 1,
    title: 'Visibility & Engagement',
    desc: 'A website is only effective if it reaches a target audience and keeps them interested. Our web development services are designed to appreciate visibility and user engagement from the very beginning. Structured layouts, clear coding, and fast-loading pages help search engines index your website better.',
    isRed: true
  },
  {
    id: 2,
    title: 'Organic Traffic, Leads, Conversion',
    desc: 'We create websites that adhere to the latest SEO best practices. Visible results in search engine rankings are a result of ordered content, shorter loading times, mobile responsiveness, and a clean source code. You can increase organic traffic to your website without depending entirely on paid advertising.',
    isRed: false
  },
  {
    id: 3,
    title: 'SEO Friendly Architecture',
    desc: "We design each website with SEO-friendly architecture to ensure better visibility. It's not only about outstanding design; it's also about building in a way that allows customers to find your business. From clean URLs & optimized metadata to mobile responsiveness, we ensure everything that helps search engines understand your site.",
    isRed: true
  },
  {
    id: 4,
    title: 'Fast Loading & Productive',
    desc: 'We have professional designers who are proficient in creating productive websites with fast loading that are useful for any browser and device. A slow speed of website can frustrate users and lower your search rankings. Every second matters while users are looking at your website. A lightning-fast website also encourages improved conversion rates and customer satisfaction.',
    isRed: false
  },
  {
    id: 5,
    title: 'UI/UX Focused Designs',
    desc: 'UI/UX-focused designs are designed for the engagement of clients, minimal navigation, and true actions. Every design element is smartly chosen for better understanding and implementation, so that your website not only looks good but also works well for the viewers. We employ visual hierarchy, spacing, color, and typography to lead users around your website.',
    isRed: true
  },
  {
    id: 6,
    title: 'Web Maintenance & Support',
    desc: 'Many website development clients in Pakistan frequently turn to us for continuing assistance because we respond promptly, manage changes efficiently, and provide consistent performance over time. With our maintenance services, you can concentrate on building your business while we manage your website.',
    isRed: false
  }
];

function WebDevBenefitsSection() {
  return (
    <section className="webdev-benefits-section">
      <div className="container">
        {/* Section Header */}
        <div className="webdev-benefits-header">
          <div className="webdev-benefits-badge-row">
            <span className="webdev-benefits-badge">Key Benefits</span>
            <div className="webdev-benefits-badge-line"></div>
          </div>
          <h2 className="webdev-benefits-title">
            Driving Your Brand Towards Boundless Expansion
          </h2>
          <p className="webdev-benefits-desc">
            To help businesses establish a strong and lasting online presence, combine experienced development, smart design, and trusted assistance to create websites that evolve with your brand. We provide the top-notch resources and assistance you need to move forward with confidence. It is known that your website is more than simply a platform; it is a reflection of your business identity, a lead generator, and a communication hub.
          </p>
        </div>

        {/* 6 Cards Grid (3x2 Alternating Red/White) */}
        <div className="webdev-benefits-grid">
          {webDevBenefitsData.map((item) => (
            <div
              key={item.id}
              className={`webdev-benefit-card ${item.isRed ? 'card-red' : 'card-white'}`}
            >
              <h3 className="webdev-benefit-card-title">{item.title}</h3>
              <p className="webdev-benefit-card-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WebDevBenefitsSection;
